export default 'condoPage';
